import { IUserAccessResponse } from '@soposopo/sopo-models';
import { ExperienceData, ProfileComponent, ProfileData, Tag } from './profile.state';
import { createAction, props } from "@ngrx/store";

export const profileRequestedAction = createAction(
    '[Profile Effects login$] Profile requested',
    props<{
        profileId: string;
    }>()
);

export const profileFetchSucceededAction = createAction(
    '[Profile Service AngularFirestore] Profile fetch succeeded',
    props<{
        profileData: ProfileData;
    }>()
);

export const clearProfileAction = createAction(
    '[Profile Effects logout$] Profile Cleared',
);

export const profileFetchFailedAction = createAction(
    '[Profile Service AngularFirestore] Profile fetch failed',
    props<{
        error: string;
    }>()
);

export const profileSetDefaultAvatarAction = createAction(
    '[Profile Set Default Avatar$] Profile Defaukt avatar$',
    props<{
        defaultAvatar: boolean;
    }>()
);

export const profileSetGPSAction = createAction(
    '[Profile Enable GPS$] Profile enable GPS',
    props<{
        gps: boolean;
    }>()
);

export const profileSetLastNameChangeAction = createAction(
    '[Profile last name changes] Profile name changed',
);

export const updateCurrenciesActio = createAction(
    '[Profile diamonds changes] Profile diamonds changed',
    props<{
        diamonds: number;
        golds: number;
    }>()
);

export const setProfileTagsAction = createAction(
    '[Profile tags] Profile tags',
    props<{
        tags: {[index: string]: Tag};
    }>()
)

export const setExperienceAction = createAction(
    '[Profile experience] Profile experience',
    props<{
        experienceData: ExperienceData;
    }>()
)

export const updateNextDailyAndNextStreakAction = createAction(
    '[Profile Daily And Streak] Update Next Daily And Next Streak',
    props<{
        timestamps: IUserAccessResponse
    }>()
)

export const activateProfileComponent = createAction(
    "[Profile component] ACTIVATE PROFILE COMPONENT",
    props<{
        component: ProfileComponent;
    }>()
);

export const acceptTermsOnRegistrationPage = createAction(
    '[Profile Accept Terms On Registration] Accept Terms On Registration',
);
